import { render } from "./WholesaleCustomersList.vue?vue&type=template&id=7cfc4007"
import script from "./WholesaleCustomersList.vue?vue&type=script&lang=js"
export * from "./WholesaleCustomersList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__